import React, { useState, useEffect, useMemo, useCallback } from 'react'
import cn from 'classnames'
import generateUuid from 'uuid/v4'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { isEmpty } from 'lodash'

import { getIsOrderCancelled, getOrderInProgress } from '../../../selectors/order'
import {
  getRoundUpForCharityFeatureEnabled,
  getTabsModeEnabled,
  getTipsEnabled,
  getUseNormalTaxRounding,
  getUseTaxClasses,
  makeGetCurrentMenu,
} from '../../../selectors/menus'
import { getTaxByItem, getTaxRate, getTotal, getCartItems } from '../../../selectors/cart'
import { getCashEnabled } from '../../../selectors/revenueCenter'
import { getMenuServiceCharge } from '../../../selectors/items'
import { getTipOnCardReader } from '../../../selectors/peripheral'

import GratuityHeader from '../../../components/GratuityHeader'
import VNLoader from '../../../VNLoader/components/VNLoader'
import useRemoteOrderTotal from '../../../hooks/useRemoteOrderTotal'
import {
  addPaymentToOrderInProgress,
  addTipOrderInProgress,
  clearOrderInProgress,
  closeNoOpTender,
  syncAndSaveOrderInProgress,
  restoreQRPaymentandAuthorizationFailedStatus,
  startOnlineCardOrder,
  deleteDiscountsFromTabOrder,
  startATab,
  setIsOrderCancelled,
  updateSavedPayment,
  addDonationsToOrderInProgress,
  updateOrderInProgress,
} from '../../../actions/order'
import { centsToDollars } from '../../../utils/formatters'
import { SIGNATURE_THRESHOLD_AMOUNT } from '../../../constants'
import styles from './TenderSelect.module.scss'
import ConfirmModalV2 from '../../../components/ConfirmModalV2'
import useOfflineModal from '../../../hooks/useOfflineModal'
import { getDeviceMode } from '../../../VNMode/Selectors'
import { MODES } from '../../../VNMode/Reducer'

import { useDispatch } from 'react-redux'
import { useSelector } from 'react-redux'
import { CFD_SCREEN } from '../../../VNCustomerFacingDisplay/Reducer'
import { calculateCartTotals } from '../../../utils/orderTotalUtils'
import {
  getCurrentCart,
  getCurrentPaymentFlow,
  getIsPaired,
  getPaymentProgress,
} from '../../../VNCustomerFacingDisplay/Selectors'
import useCreateOrderInProgress from '../../../hooks/useCreateOrderInProgress'
import {
  bridge_hijackedExecuteSalesRequest,
  sendCFDScreenNav,
  sendUpdateCart,
} from '../../../VNAndroidSDK/bridgeCalls/VNWebSDKDataSend'
import { CFD_POS_PAYMENT_FLOWS } from '../../../VNCustomerFacingDisplay/Enums'
import {
  setBlockRichCheckoutOrderDialog,
  setCashPaymentAlreadyAppliedModal,
  setCFDNotPairedDialog,
  setConfirmPaymentDialog,
  setCustomerPayingWithCard,
  SetOfflineDialog,
  setOpenCustomerPaymentDialog,
} from '../../../VNDialogs/ActionCreators'
import {
  resetCFD,
  setCurrentPaymentFlow,
  setUserProgress,
  updateCurrentOrder,
} from '../../../VNCustomerFacingDisplay/ActionCreators'
import { getCustomerPaymentDialogOpen } from '../../../VNDialogs/Selectors'
import { nextPosOrderNumber } from '../../../utils/orderNumbers'
import VNConcessionsNavBar from '../../../components/VNConcessionsNavBar'
import useGetIsMobileScreen from '../../../hooks/useGetIsMobileScreen'
import VNBottomButton from '../../../components/VNBottomButton'
import { INTERNAL_ORDER_STATES, isTabbed } from '../../../utils/orderStates'
import { clearCart, setSignatureDefaults } from '../../../actions/cart'
import { PAYMENT_TYPES, PAYMENT_TYPES_INTERNAL } from '../../../utils/paymentTypes'
import useSpinner from '../../../context/hooks/useSpinner'
import { getBackbarMode, getNetworkAvailable } from '../../../selectors/config'
import useTenders from '../../../VNTenders/hooks/useTenders'
import { clearPromotionsOnOrder } from '../../../actions/promotion'
import { setBridgePaymentMethod } from '../../../actions/peripheral'
import { bridgePaymentMethods } from '../../../reducers/peripheral'
import { getDiscountsAvailable, getSelectedPromotions } from '../../../selectors/promotion'
import { setManagerApprovalPrompt } from '../../../VNManagerApproval/ActionCreators'
import DiscountsButton from './DiscountsButton'
import { getRemoteOrderTotal } from '../../../selectors/orderTotalRemote'
import { setRoute } from '../../../VNRoutes/ActionCreators'
import TenderItem from '../../../VNTenders/components/TenderItem'
import CartItemsViewModel from '../../../viewmodels/CartItemsViewModel'
import usePrinter from '../../../VNPrinters/hooks/usePrinter'
import { useAuths } from '../../../VNTenders/hooks/useAuths'
import { getReopenedTabPayments } from '../../../VNTenders/Selectors'
import { getIsOrderTaxExempt, getTaxClasses, getTaxRules } from '../../../VNTaxes/Selectors'
import VNTenderSelectTaxButton from '../../../VNTaxes/components/VNTenderSelectTaxButton'
import useTaxResults from '../../../VNTaxes/hooks/useTaxResults'

import { isFeatureOn } from '../../../VNConfigurations/Selectors'
import { VNCONFIGS_FEATURE_ENABLEMENT_KEYS } from '../../../VNConfigurations/Enums'
import { getPpiConfigurationError } from '../../../VNPPI/Selectors'
import { APPLICATION_STRINGS } from '../../../strings'
import { setReopenedTabPaymentsAction } from '../../../VNTenders/ActionCreators'

const cancelModalTexts = {
  [PAYMENT_TYPES.TICKET]: 'Canceling this transaction will return\nall funds to your tickets.',
  [PAYMENT_TYPES.GIFT_CARD]: 'The gift card will not be charged.',
  [PAYMENT_TYPES.QR_PAY]: 'The mobile account will not be\ncharged.',
}

const TenderSelect = ({
  history,
  addPaymentToOrder,
  className,
  closeNoOpTender,
  discounts,
  goBack,
  isNewOrder,
  isTabOrder,
  modalSubtext,
  offlineTotal,
  order,
  orderAmountInCents,
  push,
  tenderAmountInCents,
  tipsEnabled,
  previousPaymentType,
  cartItems,
  cartItemModel,
  taxRate,
  taxByItem,
  menuServiceCharge,
  menuTipSuggestions,
  paymentProgress,
  cfdMode,
  fromSplit,
  fromDiscounts,
  fromDiscountsCancel,
}) => {
  const dispatch = useDispatch()

  // SELECTORS
  const customerPaymentDialog = useSelector((state) => getCustomerPaymentDialogOpen(state))
  const currentPaymentFlow = useSelector((state) => getCurrentPaymentFlow(state))
  const orderInProgress = useSelector((state) => getOrderInProgress(state))
  const orderWasCancelled = useSelector((state) => getIsOrderCancelled(state))
  const isUniqueInvoiceNumbersEnabled = useSelector((state) =>
    isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.UNIQUE_INVOICE_NUMBERS),
  )
  const isBackBar = useSelector(getBackbarMode)
  const useNormalTaxRounding = useSelector(getUseNormalTaxRounding)
  const reopenedTabPayments = useSelector((state) => getReopenedTabPayments(state, order.uuid))
  const isCFDPaired = useSelector(getIsPaired)
  const taxExempt = useSelector(getIsOrderTaxExempt)
  const { stashAuthPaymentForLaterUse } = useAuths()

  const classNames = cn(styles.tenderSelect, className)
  const paymentId = generateUuid()

  const allReopenedTabPayments = useMemo(() => {
    return reopenedTabPayments.valueSeq().toArray()
  }, [reopenedTabPayments])

  const currentPayment = useMemo(() => {
    if (fromSplit) {
      if (reopenedTabPayments.size === 1) {
        return PAYMENT_TYPES_INTERNAL.REOPEN_SAVED_CARD
      }
      return ''
    }
    const firstPayment = order.payments?.[0]?.paymentType ?? order.payments?.[0]?.shortDescription
    if (firstPayment === PAYMENT_TYPES_INTERNAL.CREDIT_CARD) {
      return PAYMENT_TYPES_INTERNAL.SAVED_CARD
    }

    if (firstPayment === PAYMENT_TYPES_INTERNAL.SPLIT_SAVED_CARD) {
      return PAYMENT_TYPES_INTERNAL.SAVED_CARD
    }

    if (firstPayment === PAYMENT_TYPES_INTERNAL.CREDIT_CARD_FP) {
      return PAYMENT_TYPES_INTERNAL.SAVED_CARD
    }
    if (order.reopened) {
      if (reopenedTabPayments.size > 1) {
        return PAYMENT_TYPES_INTERNAL.SPLIT
      }
      return PAYMENT_TYPES_INTERNAL.REOPEN_SAVED_CARD
    }
    return firstPayment
  }, [fromSplit, order.payments, reopenedTabPayments.size, order.reopened])

  const currentSelectedPaymentId = useMemo(() => {
    if (!reopenedTabPayments.size) return null

    // pre-select reopened payment
    if (order.reopened) {
      return reopenedTabPayments.first()?.paymentId
    }

    // pre-select the saved card for splits
    if (fromSplit) {
      return reopenedTabPayments.first()?.paymentId
    }

    // pre-select the saved card for splits
    if (fromSplit && reopenedTabPayments.size === 1) {
      return reopenedTabPayments.first()?.paymentId
    }
    return null
  }, [order.reopened, reopenedTabPayments, fromSplit])

  const [isPristine, setIsPristine] = useState(true)
  const [selectedPaymentType, setSelectedPaymentType] = useState(currentPayment)
  const [selectedPaymentId, setSelectedPaymentId] = useState(currentSelectedPaymentId)
  const [tenderDisplayName, setTenderDisplayName] = useState('')
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [nextButtonClicked, setNextButtonClicked] = useState(false)
  const [loadRemoteOrderTotal, { success, failed }] = useRemoteOrderTotal()
  const remoteOrderTotal = useSelector(getRemoteOrderTotal)
  const { reprintSlipHandler } = usePrinter()
  const networkAvailable = useSelector(getNetworkAvailable)
  // Use calculated offline total when remote fails
  const total = useMemo(() => {
    if (!isNewOrder) {
      return tenderAmountInCents
    }

    // If remote succeeded, use remote total
    if (success && remoteOrderTotal?.totalAmountInCents) {
      return remoteOrderTotal.totalAmountInCents
    }
    // If failed or offline, use freshly calculated offline total
    if (failed || !networkAvailable) {
      return offlineTotal
    }

    return remoteOrderTotal?.totalAmountInCents ?? offlineTotal
  }, [isNewOrder, success, failed, networkAvailable, remoteOrderTotal, offlineTotal, tenderAmountInCents])

  const roundUpForCharityEnabled = useSelector((state) => getRoundUpForCharityFeatureEnabled(state, total))
  const tenderDisplay = centsToDollars(total)
  const ppiConfigurationError = useSelector(getPpiConfigurationError)
  const threshHoldExceeded =
    (SIGNATURE_THRESHOLD_AMOUNT || SIGNATURE_THRESHOLD_AMOUNT === 0) && total > SIGNATURE_THRESHOLD_AMOUNT
  const tabsModeEnabled = useSelector(getTabsModeEnabled)
  const { blockRichCheckoutOrderText, getAvailableTenders, getBackBarTenders, addReopenPayment, orderHasCashPayment } =
    useTenders()

  const disablePPISplitOffline = useSelector((state) =>
    isFeatureOn(state, VNCONFIGS_FEATURE_ENABLEMENT_KEYS.DISABLE_PPI_SPLIT_OFFLINE),
  )

  const { taxAmountInCents, exemptedTaxAmountInCents } = useTaxResults()
  const isMobileViewPort = useGetIsMobileScreen()

  const availableTenders = useMemo(() => {
    if (isBackBar) {
      return getBackBarTenders()
    }
    return getAvailableTenders(fromSplit, previousPaymentType)
  }, [getAvailableTenders, getBackBarTenders, isBackBar, fromSplit, previousPaymentType])
  const [maximumAmount, setMaximumAmount] = useState(null)

  const shouldShowTips = useMemo(() => {
    if (isBackBar) return false

    return tipsEnabled
  }, [tipsEnabled, isBackBar])

  const signatureRequired = useMemo(() => {
    if (isBackBar) return false
    if (tipsEnabled && !order.hasTipApplied) return true
    if (!threshHoldExceeded) return false
    if (isMobileViewPort) return false

    return true
  }, [tipsEnabled, order.hasTipApplied, isBackBar, threshHoldExceeded, isMobileViewPort])

  const [checkIfOfflineWithCallback, offlineModal] = useOfflineModal()
  const [createOrder, orderCreated] = useCreateOrderInProgress()
  const currentCart = useSelector((state) => getCurrentCart(state))
  const [cartTotals, setCartTotals] = useState()
  const showTipOnCardReader = useSelector(getTipOnCardReader)
  const discountsAvailable = useSelector(getDiscountsAvailable)
  const taxClasses = useSelector(getTaxClasses)
  const taxRules = useSelector(getTaxRules)
  const useTaxClasses = useSelector(getUseTaxClasses)
  const tipSuggestions = remoteOrderTotal?.tipSuggestions ?? menuTipSuggestions

  const { stopSpinner, startSpinner } = useSpinner()

  let modal = null

  useEffect(() => {
    if (paymentProgress?.tipAmount && customerPaymentDialog?.get('open') && !isTabOrder) {
      createOrder()
      return
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentProgress, customerPaymentDialog])

  useEffect(() => {
    dispatch(setSignatureDefaults(null, null, false, null))

    if (fromDiscounts) {
      stopSpinner()

      if (fromDiscountsCancel) {
        return
      }
    }

    if (orderWasCancelled && !fromDiscounts && !fromSplit) {
      stopSpinner()
      return
    }

    // when routing back to tender select from split, clean the data. Going to split is removing the payments from the order in progress
    // and we need to make sure we reset the reopenedTabPayments in that case and populate the order in progress with the correct payments.
    if (!fromSplit && !fromDiscounts && !order.reopened && reopenedTabPayments.size > 0) {
      dispatch(updateOrderInProgress({ payments: allReopenedTabPayments }))
      dispatch(setReopenedTabPaymentsAction({ orderUuid: order?.uuid, payments: [] }))
    }

    if (isNewOrder && !isTabOrder) {
      loadRemoteOrderTotal(true)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    if (previousPaymentType === PAYMENT_TYPES.FIXED_CUSTOM_TENDER && fromSplit) {
      stopSpinner()
      dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.AUTO_SPLIT))
      sendCFDScreenNav(CFD_SCREEN.BALANCE_DUE, {
        balanceToBePaid: { amountPaid: order?.amountInCents - tenderAmountInCents, balanceDue: tenderAmountInCents },
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [previousPaymentType, fromSplit, tenderAmountInCents])

  useEffect(() => {
    return () => {
      dispatch(setIsOrderCancelled(false))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    setIsPristine(currentPayment === selectedPaymentType)
  }, [currentPayment, selectedPaymentType])

  useEffect(() => {
    const tipAmount = parseInt(paymentProgress?.tipAmount)
    if (paymentProgress?.tipAmount && customerPaymentDialog?.get('open') && (orderCreated || isTabOrder)) {
      dispatch(setOpenCustomerPaymentDialog({ open: false }))
      if (paymentProgress?.charityAmountInCents) {
        dispatch(addDonationsToOrderInProgress(parseInt(paymentProgress?.charityAmountInCents)))
      }
      dispatch(addTipOrderInProgress(tipAmount))
      handlePaymentFlowNavigation(tipAmount)
    }

    if (maximumAmount && total > maximumAmount && orderCreated) {
      addPaymentToOrder(maximumAmount, paymentId, selectedPaymentType, tenderDisplayName, maximumAmount, fromSplit)
      setNextButtonClicked(false)
      setSelectedPaymentType('')
      setSelectedPaymentId(null)
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paymentProgress, customerPaymentDialog, orderCreated])

  const handlePaymentFlowNavigation = (tipAmount) => {
    switch (currentPaymentFlow) {
      case CFD_POS_PAYMENT_FLOWS.TICKET:
        checkIfOfflineWithCallback(() => push('/ticket'), offlineModalMessage, disablePPISplitOffline)
        break
      case CFD_POS_PAYMENT_FLOWS.GIFT_CARD:
        checkIfOfflineWithCallback(() => push('/gift-card'), offlineModalMessage, disablePPISplitOffline)
        break
      case CFD_POS_PAYMENT_FLOWS.CUSTOM_TENDER:
        if (maximumAmount && total > maximumAmount) {
          const paymentAmount = maximumAmount && total > maximumAmount ? maximumAmount : total
          addPaymentToOrder(paymentAmount, paymentId, selectedPaymentType, tenderDisplayName, maximumAmount, fromSplit)
          setNextButtonClicked(false)
          setSelectedPaymentType('')
          setSelectedPaymentId(null)
          return
        }

        closeNoOpTender({
          order,
          orderUuid: order.uuid,
          tender: {
            name: selectedPaymentType,
            displayName: tenderDisplayName,
          },
          tipAmountInCents: tipAmount,
          redirectOnSync: true,
        })
        break
      default:
        checkIfOfflineWithCallback(() => push('/qr-pay'), offlineModalMessage, disablePPISplitOffline)
        sendCFDScreenNav(CFD_SCREEN.PRESENT_QR_PAY_CODE, { cartTotals: { ...cartTotals, uuid: orderInProgress.uuid } })
        break
    }
  }

  const showDiscountsButton = useMemo(() => {
    if (!discountsAvailable) return false
    if (!tabsModeEnabled) return false
    if (fromSplit) return false
    if (isTabOrder && !order?.wasCreatedInStadium) return false

    return true
  }, [discountsAvailable, tabsModeEnabled, fromSplit, order?.wasCreatedInStadium, isTabOrder])

  const showTaxExemptButton = useMemo(() => {
    if (!tabsModeEnabled) return false
    if (fromSplit) return false

    if (taxAmountInCents <= 0 && !exemptedTaxAmountInCents) return false

    return true
  }, [taxAmountInCents, tabsModeEnabled, fromSplit, exemptedTaxAmountInCents])

  const showTopButtonsContainer = showDiscountsButton || showTaxExemptButton

  const handleCashSelection = () => {
    if (orderHasCashPayment) {
      dispatch(setCashPaymentAlreadyAppliedModal({ open: true }))
      return
    }

    if (isNewOrder) {
      push('/change-calculator')
      return
    }
    push({
      pathname: `/change-calculator/${paymentId}`,
      state: {
        tenderAmountInCents,
      },
    })
  }

  const shouldNavigateToCharity = () => {
    return roundUpForCharityEnabled && !fromSplit && !showTipOnCardReader && !isBackBar
  }

  const handleCardSelection = () => {
    // if we are using a CFD with the POS
    if (cfdMode === MODES.POS) {
      if (!isCFDPaired) {
        dispatch(setCFDNotPairedDialog(true))
        return
      }
      // that we have an order that is a not full amount
      if (tenderAmountInCents > 0 || isTabOrder) {
        dispatch(updateCurrentOrder({ amount: tenderAmountInCents }))

        const onlineCardOrder = {
          cardReaderData: { uuid: order?.uuid },
          orderState: INTERNAL_ORDER_STATES.PREAUTH,
          tipAmountInCents: order?.tipAmountInCents,
          charityAmountInCents: order?.charityAmountInCents,
        }

        // first payment will not have an order in progress and incrementing the POS orderNumber will just overwrite
        // the POS orderNumber from concessionsCartSidebar. get first orderNumber from current cart and every subsequent
        // payment will increment the order number.
        if ((orderInProgress && 'orderNumber' in orderInProgress) || (currentCart.get && !currentCart.get('orderNumber'))) {
          const orderNumber = nextPosOrderNumber()
          onlineCardOrder.cardReaderData.orderNumber = orderNumber
        } else {
          const orderNumber = currentCart.get && currentCart?.get('orderNumber')
          onlineCardOrder.cardReaderData.orderNumber = orderNumber
        }

        // TODO: [T36715] - currently only works for local orders (not stadium orders)
        // Start pre auth submission if order does not have one.
        if (!isTabOrder && !order.isTab) {
          dispatch(startOnlineCardOrder(onlineCardOrder))
        } else {
          if (!fromSplit) {
            initializeCFDPayment(true, { paymentType: PAYMENT_TYPES_INTERNAL.CREDIT_CARD })
            return
          }
        }

        // show modal on POS
        dispatch(setCustomerPayingWithCard({ open: true, amount: tenderAmountInCents }))
        // lite up the card reader immediately
        bridge_hijackedExecuteSalesRequest(
          tenderAmountInCents,
          onlineCardOrder.cardReaderData.orderNumber,
          order?.amountInCents,
          fromSplit && order?.balanceDueInCents - tenderAmountInCents === 0, // determines if this is the last payment
          order?.uuid,
        )
      } else {
        startSpinner()
        history.push({
          pathname: '/concession-order',
          state: {
            payment: 'card',
          },
        })
      }
    } else {
      if (signatureRequired && !showTipOnCardReader) {
        if (isNewOrder) {
          push('/signature')
          return
        }

        push({
          pathname: `/signature/${paymentId}`,
          state: {
            order: order,
            tenderAmountInCents,
          },
        })
        return
      }

      if (tenderAmountInCents === 0 && isTabOrder) {
        if (shouldNavigateToCharity()) {
          navigateToCharity({
            fromCardLoader: true,
            totalInCents: total,
            orderId: order?.uuid,
            paymentId: !isNewOrder && paymentId,
          })
          return
        }

        addPaymentToOrder(total, paymentId, 'cash', 'Cash')
        return
      }

      if (isBackBar) {
        dispatch(setBridgePaymentMethod(bridgePaymentMethods.executeAuthRequest))
        if (isNewOrder) {
          dispatch(setRoute('/card-reader', { paymentId: !isNewOrder && paymentId, authTabs: true, startNewTab: true }))
          return
        }
      }

      if (shouldNavigateToCharity()) {
        navigateToCharity({
          fromCardLoader: true,
          totalInCents: total,
          orderId: order?.uuid,
          paymentId: !isNewOrder && paymentId,
        })
        return
      }

      push({
        pathname: `/card-reader`,
        state: {
          orderUuid: order.uuid,
          paymentId: !isNewOrder && paymentId,
          tenderAmountInCents: !isNewOrder && total,
          authTabs: isBackBar,
        },
      })
    }
  }

  const handleScanScreenSelection = (scanScreenPath) => {
    if (tipsEnabled && (isNewOrder || (isTabOrder && !fromSplit))) {
      push({
        pathname: '/signature',
        state: {
          addTipThenRedirectPath: scanScreenPath,
        },
      })
      return
    }

    if (shouldNavigateToCharity()) {
      history.push({
        pathname: '/charity',
        state: {
          fromScanScreen: true,
          totalInCents: total,
          redirectPath: scanScreenPath,
        },
      })
      return
    }
    push(scanScreenPath)
  }

  const handleCustomTender = () => {
    const paymentAmount = maximumAmount && total > maximumAmount ? maximumAmount : total

    // new BackBar Order starts tab
    if (isBackBar && isNewOrder) {
      const orderNumber = nextPosOrderNumber()
      dispatch(
        startATab({
          tabName: orderNumber,
          paymentId,
          paymentType: selectedPaymentType,
          printAuth: true,
          shortDescription: tenderDisplayName,
          redirectPath: '/concession-order',
        }),
      )
      return
    }

    if (!isNewOrder && (!isTabOrder || fromSplit)) {
      addPaymentToOrder(paymentAmount, paymentId, selectedPaymentType, tenderDisplayName, maximumAmount, fromSplit)
      setNextButtonClicked(false)
      setSelectedPaymentType('')
      setSelectedPaymentId(null)
      return
    }

    // saved auth card for fixed custom tender tabs
    const savedAvailableAuthId =
      (isTabOrder && maximumAmount && stashAuthPaymentForLaterUse()) || reopenedTabPayments.first()?.paymentId || false

    // we don't have tips for custom tender cfd mode
    if (shouldShowTips && cfdMode !== MODES.POS) {
      push({
        pathname: `/signature`,
        state: {
          maximumAmount: maximumAmount,
          customTender: { name: selectedPaymentType, displayName: tenderDisplayName },
          tenderAmountInCents: total,
        },
      })

      return
    }

    if (isTabOrder) {
      // prevent custom tender for now T43776
      // if (isCharityEnabled && roundUpForCharityEnabled && cfdMode !== MODES.POS) {
      //   navigateToCharity({
      //     fromCardLoader: true,
      //     totalInCents: total,
      //     maximumAmount: maximumAmount,
      //     shouldRedirect: false,
      //     customTender: { name: selectedPaymentType, displayName: tenderDisplayName },
      //   })
      //   return
      // }
      startSpinner()
      addPaymentToOrder(paymentAmount, paymentId, selectedPaymentType, tenderDisplayName, maximumAmount, fromSplit)

      // reset next button
      setNextButtonClicked(false)

      // reset current selected payment
      if (savedAvailableAuthId) {
        setSelectedPaymentType(PAYMENT_TYPES_INTERNAL.REOPEN_SAVED_CARD)
        setSelectedPaymentId(savedAvailableAuthId)
        setMaximumAmount(null)
        return
      }
      if (maximumAmount) {
        setSelectedPaymentType('')
        setSelectedPaymentId(null)
        setMaximumAmount(null)
        return
      }
      return
    }

    // no tabs
    if (total > paymentAmount) {
      startSpinner()
      createOrder()
      return
    }

    // prevent custom tender for now T43776
    // if (isCharityEnabled && roundUpForCharityEnabled && cfdMode !== MODES.POS) {
    //   navigateToCharity({
    //     fromCardLoader: true,
    //     totalInCents: total,
    //     maximumAmount: maximumAmount,
    //     shouldRedirect: false,
    //     customTender: { name: selectedPaymentType, displayName: tenderDisplayName },
    //   })
    //   return
    // }

    closeNoOpTender({ tender: { name: selectedPaymentType, displayName: tenderDisplayName }, redirectOnSync: true })
  }

  const navigateToCharity = (params) => {
    history.push({
      pathname: '/charity',
      state: {
        ...params,
      },
    })
  }

  useEffect(() => {
    if (cfdMode !== MODES.POS) return

    if (!isTabOrder) {
      sendUpdateCart(cartItemModel, discounts)
      return
    }

    sendUpdateCart(order?.itemModels, discounts)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cfdMode, isTabOrder, discounts, order?.itemModels])

  const initializeCFDPayment = (isFinalizingTip = false, tenderData = {}) => {
    // this was mutating the order object in the redux store
    let tabbedOrderInProgress = { ...order }

    // offline orders should not get into this if statement since we don't have the remote order total.
    // and it also doesn't matter for offline since we don't support discounts for offline orders.
    if (order.isTab && networkAvailable) {
      // When there is a tabbed order, the order in progress does not contain the full amount if there is a discount present.
      // (Discount is already deducted from the Amount)
      // The reason the amount in cents is adjusted here is in case the user wants to apply a tip to the order.

      tabbedOrderInProgress.subtotalAmountInCents = order?.orderTotalFromOrder?.subtotalInCents ?? order?.subtotalAmountInCents
    }

    const _calculatedCartValues = calculateCartTotals({
      remoteOrderTotal,
      cartItems,
      taxRate,
      taxByItem,
      menuServiceCharge,
      orderInProgress: tabbedOrderInProgress,
      isFinalizingTip,
      tenderData,
      useNormalTaxRounding,
      useTaxClasses,
      taxClasses,
      taxRules,
      taxExempt,
    })
    // cant use tips enabled for tender select because it returns the wrong value.
    dispatch(
      setOpenCustomerPaymentDialog({ open: true, tipsEnabled: !isEmpty(tipSuggestions), amount: _calculatedCartValues?.total }),
    )
    setCartTotals(_calculatedCartValues)
    dispatch(setUserProgress({})) // reset the user progress incase of a tip already existing
    sendCFDScreenNav(CFD_SCREEN.CARD_PAYMENT, {
      cartTotals: _calculatedCartValues,
      executeSalesRequest: false,
      tips: { enabled: !isEmpty(tipSuggestions), suggestions: tipSuggestions },
    })
  }

  const offlineModalMessage = isMobileViewPort
    ? 'This payment tender is not supported while the device is offline'
    : 'This payment tender is not supported\nwhile the device is offline'

  const offlineGiftCardModalMessage = isMobileViewPort
    ? 'Gift card tender is not supported while the device is offline'
    : 'Gift card tender is not supported while\n the device is offline'

  const handleSplit = () => {
    checkIfOfflineWithCallback(() => dispatch(setConfirmPaymentDialog(true)), offlineModalMessage, !isUniqueInvoiceNumbersEnabled)
  }

  const processStoredCCPayment = () => {
    if (tipsEnabled) {
      if (cfdMode === MODES.POS) {
        initializeCFDPayment(true)
        return
      }

      push({
        pathname: `/signature`,
        state: {
          closeWithSavedCard: true,
          tenderAmountInCents,
        },
      })
      return
    }
    if (cfdMode === MODES.POS) {
      initializeCFDPayment(true)
      return
    }

    if (shouldNavigateToCharity()) {
      navigateToCharity({
        closeWithStoredCard: true,
        fromCardLoader: true,
        totalInCents: total,
        shouldRedirect: false,
      })
      return
    }

    dispatch(syncAndSaveOrderInProgress())
  }

  const handleNext = () => {
    if (isPristine && isBackBar) {
      // reprint
      reprintSlipHandler()
      return
    }

    switch (selectedPaymentType) {
      case PAYMENT_TYPES_INTERNAL.SPLIT:
        handleSplit()
        break

      case PAYMENT_TYPES_INTERNAL.CREDIT_CARD:
        handleCardSelection()
        break

      case PAYMENT_TYPES_INTERNAL.CASH:
        handleCashSelection()
        break

      case PAYMENT_TYPES_INTERNAL.TICKET:
        if (ppiConfigurationError) {
          dispatch(SetOfflineDialog(true, APPLICATION_STRINGS.PPI_NETWORK_ERROR_MESSAGE))
          return
        }

        checkIfOfflineWithCallback(
          () => {
            if (cfdMode === MODES.POS) {
              dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.TICKET, true))
              initializeCFDPayment()
            } else {
              handleScanScreenSelection('/ticket')
            }
          },
          offlineModalMessage,
          disablePPISplitOffline,
        )
        break

      case PAYMENT_TYPES_INTERNAL.VIRTUAL_CURRENCY:
        // check if cart has rich checkout items
        if (blockRichCheckoutOrderText) {
          dispatch(setBlockRichCheckoutOrderDialog(true, blockRichCheckoutOrderText))
          return
        }

        // if we are using a CFD with the POS
        if (cfdMode === MODES.POS) {
          startSpinner()
          history.push({
            pathname: '/concession-order',
            state: {
              payment: 'rich_checkout',
            },
          })
        } else {
          push('/rich-checkout')
        }
        break

      case PAYMENT_TYPES_INTERNAL.QR_PAY:
        if (ppiConfigurationError) {
          dispatch(SetOfflineDialog(true, APPLICATION_STRINGS.PPI_NETWORK_ERROR_MESSAGE))
          return
        }

        if (cfdMode === MODES.POS) {
          checkIfOfflineWithCallback(
            () => {
              // set the current payment flow so we know what is happening
              dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.QR_PAY, true))
              initializeCFDPayment()
            },
            offlineModalMessage,
            disablePPISplitOffline,
          )
        } else {
          checkIfOfflineWithCallback(() => handleScanScreenSelection('/qr-pay'), offlineModalMessage, disablePPISplitOffline)
        }
        break

      case PAYMENT_TYPES_INTERNAL.GIFT_CARD:
        if (ppiConfigurationError) {
          dispatch(SetOfflineDialog(true, APPLICATION_STRINGS.PPI_NETWORK_ERROR_MESSAGE))
          return
        }

        checkIfOfflineWithCallback(
          () => {
            if (cfdMode === MODES.POS) {
              dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.GIFT_CARD, true))
              initializeCFDPayment()
            } else {
              handleScanScreenSelection('/gift-card')
            }
          },
          offlineGiftCardModalMessage,
          disablePPISplitOffline,
        )
        break

      case PAYMENT_TYPES_INTERNAL.SAVED_CARD:
        // check if order has Ticket payments applied
        // support for Ticket balance to saved card on CFD
        if (cfdMode === MODES.POS && previousPaymentType === PAYMENT_TYPES.TICKET && fromSplit) {
          dispatch(
            updateSavedPayment({
              tipAmountInCents: order.tipAmountInCents,
              charityAmountInCents: order.charityAmountInCents,
              tenderAmountInCents,
            }),
          )
          return
        }

        processStoredCCPayment()
        break

      case PAYMENT_TYPES_INTERNAL.REOPEN_SAVED_CARD:
        //if in split payment mode we need to add the payment to the order in progress the same way a custom tender is added
        if (fromSplit) {
          const paymentAmount = maximumAmount && total > maximumAmount ? maximumAmount : total
          const reopenSavedPayment = reopenedTabPayments.get(selectedPaymentId)

          reopenSavedPayment.amountInCents = paymentAmount

          addPaymentToOrder(
            paymentAmount,
            paymentId,
            selectedPaymentType,
            tenderDisplayName,
            maximumAmount,
            fromSplit,
            reopenSavedPayment,
          )
          setNextButtonClicked(false)
          setSelectedPaymentType('')
          setSelectedPaymentId(null)
          return
        }

        //restore the selected payment to the order in progress
        addReopenPayment(selectedPaymentId)
        setNextButtonClicked(false)
        setSelectedPaymentType('')
        setSelectedPaymentId(null)

        //keep processing the same way as a stored CC auth
        processStoredCCPayment()
        break

      default:
        // for cfd we don't need to disable the button because a modal pops up.
        if (cfdMode !== MODES.POS) {
          // need to disable done button if finishing a payment with custom tender
          setNextButtonClicked(true)
        }
        handleCustomTender()
    }
  }

  const onGoBack = () => {
    if (cfdMode === MODES.POS) {
      dispatch(setCurrentPaymentFlow(CFD_POS_PAYMENT_FLOWS.UNSET, true))
      dispatch(resetCFD(false))

      if (isTabOrder && !fromSplit) {
        sendCFDScreenNav(CFD_SCREEN.IDLE)
      }
    }

    if (fromDiscounts) {
      //we always need to clear promotions applied in state
      dispatch(clearPromotionsOnOrder())

      if (isTabOrder) {
        //for tab orders we need to start the spinner (is stopped in the orders screen) and call order total mutation
        startSpinner()
        dispatch(deleteDiscountsFromTabOrder())
      }
    }

    if (isTabOrder && !fromSplit) {
      dispatch(clearOrderInProgress())
      dispatch(clearCart())
    }

    //user returned from the discounts screen
    if (fromDiscounts) {
      if (isTabOrder) {
        push('/orders')
        return
      }

      push({ pathname: '/concession-order', state: { fromTenderSelect: true } })
      return
    }

    goBack()
  }

  const handleTenderSelect = useCallback(
    (paymentType, iconName, managerApproval, maximumAmountInCents, paymentId) => {
      if (paymentType === selectedPaymentType && paymentId === selectedPaymentId) return

      if (!managerApproval) {
        setSelectedPaymentType(paymentType)
        setTenderDisplayName(iconName)
        setMaximumAmount(maximumAmountInCents)
        setSelectedPaymentId(paymentId)

        return
      }

      const onSuccess = () => {
        setSelectedPaymentType(paymentType)
        setTenderDisplayName(iconName)
        setMaximumAmount(maximumAmountInCents)
        setSelectedPaymentId(paymentId)
      }

      dispatch(setManagerApprovalPrompt({ onSuccess, buttonText: 'Sign In' }))
    },
    [selectedPaymentType, selectedPaymentId, dispatch],
  )

  const TenderSelection = useCallback(() => {
    return availableTenders.map(([type, name, managerApproval, maximumAmountInCents, paymentId], idx) => {
      if (
        currentPaymentFlow === CFD_POS_PAYMENT_FLOWS.SPLIT_PAY &&
        tenderAmountInCents &&
        maximumAmountInCents &&
        tenderAmountInCents > maximumAmountInCents
      ) {
        return null
      }

      const iconName = type === PAYMENT_TYPES_INTERNAL.SAVED_CARD ? 'card' : name
      return (
        <TenderItem
          key={`${type}_${idx}`}
          selectedType={selectedPaymentType}
          selectedPaymentId={selectedPaymentId}
          handleOnClick={() => handleTenderSelect(type, iconName, managerApproval, maximumAmountInCents, paymentId)}
          {...{ name, type, handleTenderSelect, paymentId }}
        />
      )
    })
  }, [availableTenders, handleTenderSelect, selectedPaymentType, tenderAmountInCents, selectedPaymentId, currentPaymentFlow])

  if (showCancelModal) {
    modal = (
      <ConfirmModalV2
        onButtonOneClick={() => setShowCancelModal(false)}
        onButtonTwoClick={() => {
          //Reset CFD if attendant chooses to abandon order
          if (cfdMode === MODES.POS) {
            dispatch(resetCFD(true, true))
          }
          if (isTabOrder) {
            dispatch(clearOrderInProgress())
            dispatch(clearCart())
            dispatch(clearPromotionsOnOrder())
          }

          /**
           * if order has previousAuthorizationFailedStatus then that it's a failed attempt to pay with QR code
           * we set the order again to defective so it's in sync with Stadium
           */
          if (order.previousAuthorizationFailedStatus) {
            dispatch(restoreQRPaymentandAuthorizationFailedStatus(order.uuid))
          }
          push('/concession-order')
        }}
        headerText={`Cancel Transaction?`}
        subtext={modalSubtext}
        buttonOneText={'NO, NEVER MIND '}
        buttonTwoText={'YES, CANCEL'}
      />
    )
  }
  const primaryText = !isMobileViewPort ? centsToDollars(total) : ''

  const secondaryText = useMemo(() => {
    if (showTopButtonsContainer) return ''

    return !previousPaymentType ? 'Please select tender' : 'Please select a tender to pay balance due'
  }, [showTopButtonsContainer, previousPaymentType])

  const extraText = `Total: ${centsToDollars(orderAmountInCents)} • Balance Paid: ${centsToDollars(orderAmountInCents - order?.balanceDueInCents)}`

  if (!success && !failed && isNewOrder && !orderWasCancelled && !fromDiscountsCancel) {
    return <VNLoader />
  }

  return (
    <div className={classNames}>
      <VNConcessionsNavBar onClick={onGoBack} showIcon={!previousPaymentType} textDisplay={isMobileViewPort && tenderDisplay} />
      {(!isMobileViewPort || !showTopButtonsContainer) && (
        <GratuityHeader
          className={cn([styles.gratuityHeader, showTopButtonsContainer && !isMobileViewPort && styles.gratuityPadding])}
          primaryText={primaryText}
          secondaryText={secondaryText}
          extraText={!previousPaymentType ? '' : extraText}
          isSplitTender={true}
          isMobileViewPort={isMobileViewPort}
        />
      )}
      <div className={styles.tenderSelect__body}>
        {showTopButtonsContainer && (
          <div className={styles.topButtonsContainer}>
            {showDiscountsButton && <DiscountsButton selectedPaymentType={selectedPaymentType} total={total} />}
            {showTaxExemptButton && <VNTenderSelectTaxButton />}
          </div>
        )}
        <div className={cn([styles.tenderSelections])}>
          <TenderSelection />
        </div>
        <div className={cn(styles.buttonContainer, { [styles.scanScreen]: !!previousPaymentType })}>
          <VNBottomButton
            text={'Next'}
            className={styles.buttonNext}
            onClick={handleNext}
            disabled={!selectedPaymentType || nextButtonClicked}
            higherPosition={previousPaymentType}
          />
        </div>
        <div className={styles.actionButtons}>
          {previousPaymentType && (
            <div className={cn(styles.button, styles.cancelTransaction)} onClick={() => setShowCancelModal(true)}>
              Cancel Transaction
            </div>
          )}
        </div>
        {modal}
        {offlineModal}
      </div>
    </div>
  )
}

const mapStateToProps = (state, props) => {
  const push = props?.history?.push ?? (() => {})
  const offlineTotal = getTotal(state)
  const order = getOrderInProgress(state)
  const discounts = getSelectedPromotions(state)
  const tenderAmountInCents = props?.history?.location?.state?.tenderAmountInCents ?? order?.amountInCents ?? 0
  const fromSplit = props?.history?.location?.state?.fromSplit
  const fromDiscounts = props?.history?.location?.state?.fromDiscounts
  const fromDiscountsCancel = props?.history?.location?.state?.fromDiscountsCancel
  const isNewOrder = isEmpty(order)
  const isTabOrder = isTabbed(order)
  const previousPaymentType = props?.history?.location?.state?.previousPaymentType ?? ''
  const cashEnabled = getCashEnabled(state)
  const orderAmountInCents = order?.amountInCents
  const modalSubtext = cancelModalTexts[previousPaymentType]
  const cartItems = getCartItems(state)
  // TODO: this should be a selector
  const cartItemModel = CartItemsViewModel(cartItems)
  const taxRate = getTaxRate(state)
  const taxByItem = getTaxByItem(state)
  const menuServiceCharge = getMenuServiceCharge(state)
  const getMenu = makeGetCurrentMenu()
  const menu = getMenu(state)
  const paymentProgress = getPaymentProgress(state)
  const menuTipSuggestions = menu?.tipSuggestions
  const cfdMode = getDeviceMode(state)
  let tipsEnabled = getTipsEnabled(state)

  if (cfdMode === MODES.POS && !isTabOrder) {
    tipsEnabled = false
  }

  return {
    tenderAmountInCents,
    push,
    cashEnabled,
    discounts,
    order,
    isNewOrder,
    isTabOrder,
    offlineTotal,
    tipsEnabled,
    orderAmountInCents,
    previousPaymentType,
    modalSubtext,
    cartItems,
    cartItemModel,
    taxRate,
    taxByItem,
    menuServiceCharge,
    menuTipSuggestions,
    paymentProgress,
    cfdMode,
    fromSplit,
    fromDiscounts,
    fromDiscountsCancel,
  }
}

const mapDispatchToProps = (dispatch, props) => {
  const goBack = props?.history?.goBack ?? (() => {})

  return {
    goBack: () => goBack(),
    closeNoOpTender: (tender) => dispatch(closeNoOpTender(tender)),
    addPaymentToOrder: (
      tenderAmountInCents,
      paymentId,
      paymentType,
      tenderDisplayName,
      maximumAmount,
      fromSplit,
      reopenSavedPayment,
    ) => {
      dispatch(
        addPaymentToOrderInProgress({
          tenderAmountInCents,
          paymentId,
          paymentType,
          shortDescription: tenderDisplayName,
          maximumAmount: maximumAmount,
          fromSplit,
          reopenSavedPayment,
        }),
      )
    },
  }
}

TenderSelect.propTypes = {
  addPaymentToOrder: PropTypes.func,
  className: PropTypes.string,
  closeNoOpTender: PropTypes.func,
  goBack: PropTypes.func,
  isNewOrder: PropTypes.bool,
  offlineTotal: PropTypes.number,
  order: PropTypes.object,
  orderAmountInCents: PropTypes.number,
  push: PropTypes.func,
  tenderAmountInCents: PropTypes.number,
  tipsEnabled: PropTypes.bool,
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(TenderSelect))
